import { DateTimeStr } from '@mi-front/core';
import { useCallback, useEffect, useState } from 'react';

type UseFollowPlaybackParams = {
  searchQuery: string;
  seekToTimeSeconds: (timeSeconds: number, chunkTime: DateTimeStr) => void;
};

/**
 * Encapsulates follow-playback behavior for transcription:
 * - disables follow mode when a search query becomes active
 * - re-enables follow mode from explicit user actions (sync toggle or seek)
 */
export function useFollowPlayback({ searchQuery, seekToTimeSeconds }: UseFollowPlaybackParams) {
  const [followPlayback, setFollowPlayback] = useState(true);

  /** Disable follow only when a search is active, not on mount (empty query). */
  useEffect(() => {
    if (searchQuery.length > 0) {
      setFollowPlayback(false);
    }
  }, [searchQuery]);

  const enableFollowPlayback = useCallback(() => {
    setFollowPlayback(true);
  }, []);

  const disableFollowPlayback = useCallback(() => {
    setFollowPlayback(false);
  }, []);

  const seekToTimeSecondsAndFollow = useCallback(
    (timeSeconds: number, chunkTime: DateTimeStr) => {
      setFollowPlayback(true);
      seekToTimeSeconds(timeSeconds, chunkTime);
    },
    [seekToTimeSeconds],
  );

  return {
    followPlayback,
    enableFollowPlayback,
    disableFollowPlayback,
    seekToTimeSecondsAndFollow,
  };
}
